import type {LootsheetLockDuck} from '@ducks';

import type {LootsheetLock} from '@models/lootsheetLock';

/** Get whether a lootsheet is currently locked */
export function getIsLootsheetLocked(
	state: LootsheetLockDuck.State,
	data: {
		wowInstanceId: LootsheetLock['wowInstanceId'];
		difficulty: LootsheetLock['difficulty'];
	}
): boolean {
	return Object.values(state.byId).some(
		(x) => x.wowInstanceId === data.wowInstanceId && x.difficulty === data.difficulty
	);
}
